<template>
  <GenericList api-endpoint="user" ref="GenericList">
    <template v-slot:title>{{ $t('userList') }}</template>
    <template v-slot:header>
      <UserHeader />
    </template>
    <template v-slot:item="{ item, index }" v-if="getPermission() === 1">
      <UserItem :item="item" :index="index" @remove-item="removeItem" />
    </template>
    <template v-slot:item="{ item, index }" v-else>
      <UserItem
        :item="item"
        :index="index"
        @remove-item="removeItem"
        v-if="item.permission !== 1"
      />
    </template>
  </GenericList>
</template>

<script>
import UserHeader from './UserHeader.vue';
import UserItem from './UserItem.vue';
import GenericList from '../generic/GenericSearchList.vue';
import { getPermission } from '../../User';

export default {
  components: {
    UserHeader,
    UserItem,
    GenericList,
  },
  methods: {
    getPermission,
    removeItem(item) {
      if (this.$refs.GenericList) {
        this.$refs.GenericList.removeItem(item);
      }
    },
  },
};
</script>
